<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="departure-detail wrapper--spacing-vertical" data-test="departure-detail">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'departure-detail.departureDate' | translate }}</mat-label>
        <input
          matInput
          formControlName="departureDate"
          [matDatepicker]="departureDatePicker"
          placeholder="{{ 'departure-detail.departureDate' | translate }}"
          (focus)="departureDatePicker.open()"
          [value]=""
          [min]="minDepartureDate$ | async"
          data-test="departure-detail__departureDate"
        />
        <mat-datepicker-toggle matIconSuffix [for]="departureDatePicker"></mat-datepicker-toggle>
        <mat-datepicker touchUi #departureDatePicker></mat-datepicker>
        <mat-error *ngIf="formGroup.controls.departureDate.errors?.required">
          {{ 'validation-error.required' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.controls.departureDate.errors?.departureDateBeforeMinimum">
          {{ 'departure-detail.departure-date-comparison-error' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'departure-detail.amount' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          data-test="departure-detail__amount"
          formControlName="amount"
          placeholder="{{ 'departure-detail.amount' | translate }}"
        />
        <mat-error *ngIf="formGroup.controls.amount.errors?.required">
          {{ 'validation-error.required' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.controls.amount.hasError('min')">
          {{ 'departure-detail.minimum-amount-of-hens-error' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.controls.amount.errors?.departureAmountInvalid">
          {{ 'departure-detail.amount-of-hens-comparison-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'departure-detail.henWeightInGrams' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          data-test="departure-detail__weightInGrams"
          formControlName="weightInGrams"
          placeholder="{{ 'departure-detail.henWeightInGrams' | translate }}"
        />
        <span matTextSuffix class="form-field-suffix">g</span>
        <mat-error *ngIf="formGroup.controls.weightInGrams.errors?.required">
          {{ 'validation-error.required' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.controls.weightInGrams.hasError('min')">
          {{ 'departure-detail.hen-weight-error' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.controls.weightInGrams.errors?.departureWeightInvalid">
          {{ 'departure-detail.hen-weight-comparison-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'departure-detail.eggs-price' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          formControlName="eggsPrice"
          placeholder="{{ 'departure-detail.eggs-price' | translate }}"
          data-test="departure-detail__eggs-price"
        />
        <span matTextSuffix class="form-field-suffix"
          >€/100 {{ 'departure-detail.pieces' | translate }}</span
        >
        <mat-error *ngIf="formGroup.controls.eggsPrice.hasError('min')">
          {{ 'departure-detail.eggs-price-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'departure-detail.eggs-price-second-kind' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          formControlName="eggsPriceSecondKind"
          placeholder="{{ 'departure-detail.eggs-price-second-kind' | translate }}"
          data-test="departure-detail__eggs-price-second-kind"
        />
        <span matTextSuffix class="form-field-suffix"
          >€/100 {{ 'departure-detail.pieces' | translate }}</span
        >
        <mat-error *ngIf="formGroup.controls.eggsPriceSecondKind.hasError('min')">
          {{ 'departure-detail.eggs-price-second-kind-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'departure-detail.hens-price' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          formControlName="hensPrice"
          placeholder="{{ 'departure-detail.hens-price' | translate }}"
          data-test="departure-detail__hens-price"
        />
        <span matTextSuffix class="form-field-suffix">€/kg</span>
        <mat-error *ngIf="formGroup.controls.hensPrice.hasError('min')">
          {{ 'departure-detail.hens-price-error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
